import { SystemUser } from '@models';
import * as Yup from 'yup';

export function useValidationSchema() {
  return Yup.object<SystemUser>().shape({
    username: Yup.string().nullable().required(),
    email: Yup.string().nullable().required(),
  }) as Yup.Schema<SystemUser>;
}
